export const isOldPhoto = (url: string): boolean => url.startsWith('http');
